import { type ActiveListing, type ApiResult, type BaseParams, links, Request } from '@app/client';

import { apiReturnResults } from '../../../../ApiFactory';

export type UnifiedListingsFormat = string; // (chain.source.id)
// Example: ethereum.reservoir.0xc238067748f41390ea77162a2b98090754cf9d72177acda70d354f3bda85fd8d
// polygon.reservoir.0x7d111e03c814a4d8b7c9131fad93ffb0973afae0b02aa7335a794e229d8cc2ee

const getActiveListingData = (params: BaseParams): Promise<ApiResult<ActiveListing>> => {
    const target = links.daas().v2.market.listing;
    return Request.getRequest<ActiveListing>({
        ...params,
        target,
        apiSettingsType: 'daasV2',
    });
};

export const callGetActiveListingData = (params: BaseParams) =>
    apiReturnResults<ActiveListing>(getActiveListingData, params, true);

type GetListingParams = BaseParams & { listings?: UnifiedListingsFormat[] };

const getListing = (params: GetListingParams): Promise<ApiResult<ActiveListing>> => {
    const target = links.daas().v2.market.listingById;
    return Request.getRequest<ActiveListing>({
        ...params,
        target,
        apiSettingsType: 'daasV2',
    });
};

export const callGetListings = (params: GetListingParams) => apiReturnResults<ActiveListing>(getListing, params, true);
